import React, { Dispatch } from 'react';
import myReducer from '../reducers';
import { UserInfo } from '../models/interfaces';
import { Action } from '../actions';

let initialUserInfo: UserInfo = {
  userId: '',
  symptoms: {},
  contacts: {},
};

const UserInfoContext = React.createContext(initialUserInfo);
const DispatchContext = React.createContext({} as Dispatch<Action>);

function UserInfoProvider(props: any) {
  let [userInfoState, dispatch] = React.useReducer(myReducer, initialUserInfo);

  return (
    <UserInfoContext.Provider value={userInfoState}>
      <DispatchContext.Provider value={dispatch}>{props.children}</DispatchContext.Provider>
    </UserInfoContext.Provider>
  );
}

export { UserInfoContext, DispatchContext, UserInfoProvider };
